import React, {useEffect, useState} from "react";
import dayjs from "dayjs";
import {Calendar} from "primereact/calendar";
import {Dropdown} from "primereact/dropdown";
import {Tag} from "primereact/tag";
import {InputText} from "primereact/inputtext";
import {DataTable} from "primereact/datatable";
import {Column} from "primereact/column";
import {Button} from "primereact/button";
import {ToJsDate, ToMySqlDate} from "../../utilities/ToMySqlDate";
import {InputNumber} from "primereact/inputnumber";
import {numberWithCommas, sF} from "../../utilities/NumberFormatter";

import "./CashComponent.css";
export const CashComponent = ({
                                  data,
                                  customerList,
                                  selectedDate,
                                  setSelectedDate,
                                  departmentList,
                                  actions,
                                  invoiceNumber,
                                  setShowImage,
                                  setInvoiceNumber,
                                  footer,
                                  level
                              }) => {

    const dt = React.useRef(null);
    const [loading, setLoading] = useState(false);
    const [instrument] = useState(["CASH", "CHEQUE", "POST"])
    const [payment] = useState(["CREDIT", "DEBIT"])
    const [selectedData, setSelectedData] = useState({
        customerName: "",
        customerId: 0,
        departmentName: "ALL",
        departmentId: 1,
        instrument: "CASH",
        payment: "CREDIT",
        comment: "",
        amount: 0,
        postDate: selectedDate,
        posted: false,
        date: selectedDate,
        invoiceId: invoiceNumber || 0,
    })

    const rowClass = (data) => {
        return {
            'bg-blue-50 font-semibold': (data.invoiceId === selectedData?.invoiceId),
            'surface-200 opacity-70': data.posted,
            'cash-row--unposted': !data.posted,
        };
    };
    const showPostDate = (rowData) => {
        if (rowData.instrument === "POST") {
            return <span
                className="text-xs text-600 font-medium">{ToJsDate(rowData.postDate).format('DD MMM YYYY')}</span>;
        }
        return <span className="text-400">-</span>;
    }
    const handleDataSelect = (currentData) => {
        setSelectedData({
            customerName: currentData.customerName,
            customerId: currentData.customerId,
            departmentName: currentData.departmentName,
            departmentId: currentData.departmentId,
            instrument: currentData.instrument,
            payment: currentData.credit > 0 ? "CREDIT" : "DEBIT",
            comment: currentData.comment,
            amount: currentData.credit > 0 ? currentData.credit : currentData.debit,
            postDate: currentData.postDate,
            posted: currentData.posted,
            date: selectedDate,
            invoiceId: currentData.invoiceId,
        })
    }
    const numCBody = (rowData) => {
        if (rowData.debit > 0) {
            return <span className="text-green-600 font-bold">{numberWithCommas(rowData.debit)}</span>;
        }
        return <span className="text-400">-</span>;
    }
    const numDBody = (rowData) => {
        if (rowData.credit > 0) {
            return <span className="text-red-600 font-bold">{numberWithCommas(rowData.credit)}</span>;
        }
        return <span className="text-400">-</span>;
    }
    useEffect(() => {
        setSelectedData({...selectedData, invoiceId: invoiceNumber});
    }, [invoiceNumber])

    useEffect(() => {
        if (data && data.length > 0 && dt.current) {
            const tableElement = dt.current.getElement();
            const scrollableElement = tableElement.querySelector('.p-datatable-wrapper');
            if (scrollableElement) {
                scrollableElement.scrollTop = scrollableElement.scrollHeight;
            }
        }
    }, [data]);


    const doAction = (action) => {
        if (action.mode === "New") {
            setSelectedData({
                customerName: "",
                customerId: 0,
                departmentName: "ALL",
                departmentId: 1,
                instrument: "CASH",
                payment: "CREDIT",
                comment: "",
                amount: 0,
                postDate: selectedDate,
                posted: false,
                date: selectedDate,
                invoiceId: 0
            })
        } else {
            setLoading(true);
            actions({
                mode: action.mode, data: {
                    invoiceId: selectedData.invoiceId === 0 ? 0 : selectedData.invoiceId,
                    date: ToMySqlDate(selectedDate),
                    mode: selectedData.instrument === "CHEQUE" ? "CHEQ" : selectedData.instrument,
                    posted: selectedData.posted,
                    postDate: selectedData.postDate !== "" ? ToMySqlDate(selectedData.postDate) : ToMySqlDate(selectedData.date),
                    pending: selectedData.instrument === "POST",
                    credit: selectedData.payment === "CREDIT" ? selectedData.amount : 0,
                    debit: selectedData.payment === "DEBIT" ? selectedData.amount : 0,
                    customerName: selectedData.customerName,
                    customerId: selectedData.customerId,
                    departmentName: selectedData.departmentName,
                    departmentId: selectedData.departmentId,
                    comment: selectedData.comment,
                }
            })
            // Note: If 'actions' is async, you should await it here and then setLoading(false)
            // If it triggers a parent re-render, ensure the parent controls the loading state or reset it here.
            setLoading(false);
        }
    }
    if (selectedData) {
        return (
            <div
                className="flex sm:flex-column md:flex-row justify-content-start w-full gap-1  cash-dark__form overflow-hidden items-stretch"
                style={{ height: "calc(100vh - 100px)" }}
            >
                {/* Input Panel - Full width on mobile, 4/12 or 3/12 on larger screens */}
                <div
                    className="surface-card shadow-2 bg-black border-round-xl  w-full lg:w-5 xl:w-4 flex flex-column gap-1 border-1 border-200 h-full overflow-y-auto min-h-0"
                >

                    <div className="cash-dark__form flex align-items-center justify-content-between ">
                        <h3 className="cash-dark__title text-base md:text-lg font-bold m-0">Entry Details</h3>
                        <Tag value={selectedData.invoiceId === 0 ? "NEW" : `ID: ${selectedData.invoiceId}`}
                             severity={selectedData.invoiceId === 0 ? "info" : "success"}
                             className="px-2 py-1 text-xs"/>
                    </div>

                    <div className="cash-dark__form flex flex-column gap-1 h-full overflow-hidden">
                            <span className="p-float-label cash-dark__form">
                                <Calendar id="date" className="w-full p-inputtext-sm  cash-dark__form"
                                          value={selectedDate.toDate()}
                                          onChange={(e) => setSelectedDate(dayjs(e.value))}
                                          disabled={selectedData.posted}
                                          dateFormat="dd/mm/yy" showIcon selectionMode="single"/>
                                <label htmlFor="date" className="text-sm bg-warning text-black rounded">Transaction Date</label>
                            </span>

                        <span className="p-float-label">
                                <Dropdown className="w-full p-inputtext-sm"
                                          value={selectedData.customerId}
                                          options={customerList}
                                          optionLabel="name"
                                          optionValue="id"
                                          onChange={(e) => {
                                              setSelectedData({
                                                  ...selectedData,
                                                  customerName: customerList.find(c => c.id === e.target.value)?.name,
                                                  customerId: e.target.value,
                                              });
                                          }}
                                          disabled={selectedData.posted}
                                          filter
                                />
                                <label htmlFor="customer" className="text-sm bg-warning text-black rounded">Customer Account</label>
                            </span>

                        <div className="flex flex-column sm:flex-row gap-2 sm:gap-2">
                                <span className="p-float-label flex-1">
                                    <Dropdown id="paymentMode" className="w-full p-inputtext-sm"
                                              value={selectedData.instrument}
                                              options={instrument}
                                              onChange={(e) => setSelectedData({
                                                  ...selectedData,
                                                  instrument: e.value
                                              })}
                                              disabled={selectedData.posted}/>
                                    <label htmlFor="paymentMode" className="text-sm bg-warning text-black rounded">Type</label>
                                </span>

                            <span className="p-float-label flex-1">
                                    <Dropdown id="mode" className="w-full p-inputtext-sm"
                                              value={selectedData.payment}
                                              options={payment}
                                              onChange={(e) => setSelectedData({...selectedData, payment: e.value})}
                                              disabled={selectedData.posted}/>
                                    <label htmlFor="mode" className="text-sm bg-warning text-black rounded">Debit/Credit</label>
                                </span>
                        </div>

                        {selectedData.instrument === "POST" &&
                            <span className="p-float-label animate-fadein">
                                    <Calendar id="pdate" className="w-full p-inputtext-sm"
                                              value={selectedData.postDate === "" ? selectedData.date.toDate() : selectedData.postDate.toDate()}
                                              onChange={(e) => setSelectedData({
                                                  ...selectedData,
                                                  postDate: dayjs(e.value)
                                              })}
                                              dateFormat="dd/mm/yy" showIcon selectionMode="single"/>
                                    <label htmlFor="pdate" className="text-sm bg-warning text-black rounded">PDC Date</label>
                                </span>
                        }

                        <span className="p-float-label">
                                <InputNumber id="amount" className="w-full p-inputtext-sm"
                                             value={sF(selectedData.amount)}
                                             onValueChange={(e) => {
                                                 setSelectedData({...selectedData, amount: e.target.value})
                                             }}
                                             onFocus={(e) => e.target.select()}
                                             disabled={selectedData.posted || !selectedData.customerName}/>
                                <label htmlFor="amount" className="text-sm bg-warning text-black rounded">Transaction Amount</label>
                            </span>

                        <span className="p-float-label">
                                <Dropdown id="department" className="w-full p-inputtext-sm"
                                          value={selectedData.departmentId}
                                          options={departmentList}
                                          optionLabel="name"
                                          optionValue="id"
                                          disabled={selectedData.posted}
                                          onChange={(e) =>
                                              setSelectedData({
                                                  ...selectedData,
                                                  departmentName: departmentList.find(c => c.id === e.target.value)?.name,
                                                  departmentId: e.target.value || 0
                                              })}/>
                                <label htmlFor="department" className="text-sm bg-warning text-black rounded">Department</label>
                            </span>

                        <span className="p-float-label">
                                <InputText id="comment" className="w-full p-inputtext-sm"
                                           value={selectedData.comment}
                                           onChange={(e) => setSelectedData({
                                               ...selectedData,
                                               comment: e.target.value
                                           })}
                                           autoComplete="off"
                                           disabled={selectedData.posted}/>
                                <label htmlFor="comment" className="text-sm bg-warning text-black rounded">Remarks / Comments</label>
                            </span>

                        <div className="cash-dark__toolbar flex flex-row flex-wrap gap-2 justify-content-center pt-3 border-top-1 border-100">
                            <Button icon="pi pi-plus" tooltip="New" severity="secondary" rounded text raised
                                    className="p-button-sm cash-action-btn"
                                    onClick={() => doAction({mode: "New"})}
                                    disabled={loading}/>
                            <Button icon="pi pi-save" tooltip="Save" severity="success" rounded text raised
                                    className="p-button-sm cash-action-btn"
                                    onClick={() => doAction({mode: "Save"})}
                                    disabled={loading || selectedData.posted || !selectedData.customerName || !selectedData.instrument}/>
                            <Button icon="pi pi-check-circle" tooltip="Post" severity="info" rounded text raised
                                    className="p-button-sm cash-action-btn"
                                    onClick={() => doAction({mode: "Post"})}
                                    disabled={loading || selectedData.posted || selectedData.instrument === "POST" || selectedData.invoiceId === 0 || !level.posting()}/>
                            <Button icon="pi pi-undo" tooltip="Unpost" severity="warning" rounded text raised
                                    className="p-button-sm cash-action-btn"
                                    onClick={() => doAction({mode: "UnPost"})}
                                    disabled={loading || !selectedData.posted || selectedData.instrument === "POST" || !level.posting()}/>
                            <Button icon="pi pi-trash" tooltip="Delete" severity="danger" rounded text raised
                                    className="p-button-sm cash-action-btn"
                                    onClick={() => doAction({mode: "Delete"})}
                                    disabled={loading || selectedData.posted || selectedData.invoiceId === 0}/>                        </div>
                    </div>

                </div>

                {/* Table Container - Takes remaining space */}
                <div className="flex-grow-1 w-full h-full overflow-hidden min-h-0">
                    <div className="cash-dark__panel overflow-hidden flex flex-column h-full min-h-0">
                        <DataTable
                            ref={dt}
                            value={data}
                            resizableColumns
                            columnResizeMode="expand"
                            className="p-datatable-sm custom-table cash-dark__table flex-grow-1 min-h-0"
                            rows={25}
                            selectionMode="single"
                            scrollable
                            scrollHeight="flex"
                            footer={footer}
                            selection={selectedData}
                            onSelectionChange={(e) => handleDataSelect(e.value)}
                            rowClassName={rowClass}
                            stripedRows
                            showGridlines
                            tableStyle={{minWidth: '50rem'}}
                        >
                        <Column field="invoiceId" header="Folio" sortable className="text-primary font-bold "
                                    style={{width: '5rem'}}/>
                            <Column field="customerName" header="Customer Name" sortable />
                            <Column field="instrument" header="Type" style={{width: '6rem'}}
                                    body={(row) => <Tag value={row.instrument}
                                                        className=" px-1 py-0"
                                                        severity={row.instrument === 'CASH' ? 'success' : 'warning'}/>}/>
                            <Column field="postDate" header="PDC Date" body={showPostDate} style={{width: '8rem'}}
                                    />
                            <Column field="debit" header="Debit (+)" align="right" body={numCBody}
                                    style={{width: '8rem'}} headerClassName="text-green-700 bg-green-50"
                                   />
                            <Column field="credit" header="Credit (-)" align="right" body={numDBody}
                                    style={{width: '8rem'}} headerClassName="text-red-700 bg-red-50 "
                                   />
                            <Column field="departmentName" header="Dept" style={{width: '7rem'}} />
                            <Column field="comment" header="Remarks" className="text-500 italic"/>
                        </DataTable>
                    </div>
                </div>
            </div>
        );
    }
}